export default __webpack_public_path__ + "static/media/ic-link-bep20.d3ac2ae9.svg";